export default function FinalCTA() {
  return (
    <section className="py-32 bg-gradient-to-br from-[#2F7FB7] via-[#1E5A8E] to-[#2F7FB7] relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#5A9FD4]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-white/5 rounded-full blur-3xl"></div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h2 className="text-6xl md:text-7xl font-serif text-white mb-8 leading-tight">
          You're Welcome Here
        </h2>
        <p className="text-2xl text-white/90 leading-relaxed mb-12 max-w-2xl mx-auto">
          Exactly as you are. No pressure. No judgment. Just gentle support for your journey toward emotional wellbeing.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-8">
          <a href="/download" className="bg-white text-[#2F7FB7] px-10 py-5 rounded-full text-lg font-semibold hover:shadow-2xl transition-all hover:scale-105 cursor-pointer whitespace-nowrap">
            Download RECOVER
          </a>
          <a href="/download" className="bg-[#5A9FD4] text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-[#4A8FC4] transition-all cursor-pointer whitespace-nowrap">
            Learn More
          </a>
        </div>

        <p className="text-sm text-white/80 flex items-center justify-center gap-2 flex-wrap">
          <span className="flex items-center gap-2">
            <i className="ri-check-line"></i>
            Free to start
          </span>
          <span className="w-1 h-1 rounded-full bg-[#5A9FD4]"></span>
          <span className="flex items-center gap-2">
            <i className="ri-check-line"></i>
            No credit card required
          </span>
          <span className="w-1 h-1 rounded-full bg-[#5A9FD4]"></span>
          <span className="flex items-center gap-2">
            <i className="ri-check-line"></i>
            Cancel anytime
          </span>
        </p>

        {/* Trust indicators */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-serif text-white mb-2">40+</div>
            <div className="text-sm text-white/80">Years Experience</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-serif text-white mb-2">100%</div>
            <div className="text-sm text-white/80">Evidence-Based</div>
          </div>
        </div>
      </div>
    </section>
  );
}
